const Home = () => import('@/views/public/Home.vue')
const Register = () => import('@/views/public/Register.vue')
const Login = () => import('@/views/public/Login.vue')
const Reset = () => import('@/views/public/Reset.vue')
const Verification = () => import('@/views/public/Verification.vue')
const Class = () => import('@/views/public/Class.vue')

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: 'Beranda'
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "Masuk"
    }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      title: "Daftar"
    }
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: Reset,
    meta: {
      title: "Ganti Password"
    }
  },
  {
    path: "/verification",
    name: "verification",
    component: Verification,
    meta: {
      title: "Verifikasi Akun"
    }
  },
  {
    path: "/class",
    name: "class",
    component: Class,
    meta: {
      title: "Kelas Cendekia"
    }
  },
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})